import React from 'react'
import classNames from 'classnames'
import { gsap, Power2, ScrollTrigger } from 'gsap/all'
import { Close } from 'kunstmuseum-icons'

import ExpandableText from './expandable-text'
import TitleCredits from './title-credits'

gsap.registerPlugin(ScrollTrigger)

const OverlayContext = React.createContext(null);

class ClickableImage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            overlayOpened: false,
            overlayContent: null
        }

        this.domRef = React.createRef()
        this.toggleOverlay = this.toggleOverlay.bind(this)
    }

    toggleOverlay(content = null) {
        this.setState({
            overlayOpened: !this.state.overlayOpened,
            overlayContent: content
        })
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.from(this.domRef.current.querySelectorAll('.clickable-image-item'), {
                opacity: 0,
                scale: 1.2,
                ease: Power2.easeOut,
                stagger: {
                    from: 'end',
                    amount: 0.2,
                    each: 0.5
                },
                scrollTrigger: {
                    trigger: this.domRef.current,
                    toggleActions: 'play pause resume pause',
                    start: 'center 70%'
                }
            })
        })
    }

    render() {
        const { 
            imageRef, 
            maxWidth, 
            lightItems,
            expandableCaption, 
            disableOverlayColumns, 
            caption, 
            title, 
            artist, 
            year, 
            credit, 
            children
        } = this.props

        const style = {
            maxWidth: maxWidth
        }

        return (
            <div className={classNames('clickable-image', maxWidth === '100%' && 'full-width', lightItems && 'light-items')} style={style} ref={this.domRef}>
                {this.state.overlayOpened &&
                    <div className="overlay">
                        <button className="close-overlay" onClick={this.toggleOverlay}>
                            <span className="screen-reader-text">Menü schließen</span>
                            <Close className="close" />
                        </button>
                        <div style={{display: disableOverlayColumns && 'block'}}>
                            {this.state.overlayContent}
                        </div>
                    </div>
                }
                <div className="image">
                    <img src={imageRef} alt={caption} />
                    <OverlayContext.Provider value={this.toggleOverlay}>
                        {children}
                    </OverlayContext.Provider>
                </div>
                <TitleCredits 
                    title={title} 
                    artist={artist} 
                    year={year} 
                    credit={credit} 
                />
                {caption &&
                    <figcaption>
                        {expandableCaption ?
                            <ExpandableText>
                                {caption}
                            </ExpandableText>
                        :
                            caption
                        }
                    </figcaption>
                }
            </div>
        )
    }
}

class ClickableImageItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            opened: false
        }

        this.domRef = React.createRef()
        this.toggleItem = this.toggleItem.bind(this)
    }

    static contextType = OverlayContext

    toggleItem() {
        this.setState({
            opened: !this.state.opened
        })
    }

    render() {
        const { topPosition, leftPosition, openInside, openLeft, minWidth, children } = this.props

        const style = {
            top: topPosition + '%',
            left: leftPosition + '%'
        }

        const contentStyle = {
            minWidth: minWidth,
            right: openLeft && 0
        }
        
        return (
            <div className="clickable-image-item" style={style}>
                <button onClick={openInside ? this.toggleItem : () => this.context(children)}>
                    <span className="screen-reader-text">Anzeigen</span>
                    {this.state.opened ? 
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                            <rect y="9.9" className="st0" width="22" height="2.2"/>
                        </svg>
                    :
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                            <rect y="9.9" width="22" height="2.2" />
                            <rect x="9.9" width="2.2" height="22" />
                        </svg>
                    }
                    
                </button>
                {this.state.opened &&
                    <div className="content" style={contentStyle}>
                        {children}
                    </div>
                }
            </div>
        )
    }
}

const ClickableImageItemOverlayColumn = ({ children }) => (
    <div className="overlay-column">
        {children}
    </div>
)

export {
    ClickableImage,
    ClickableImageItem,
    ClickableImageItemOverlayColumn
}